import { useFormik } from "formik";
import React from "react";

import { Button, Card, Form } from "react-bootstrap";
import { setGramamMessage } from "redux/actions";


import { useAppDispatch } from "redux/store";
import { addGramam, updateGramam } from "services/gramamService";
import { Constant } from "template/Constant";
import * as yup from 'yup';
type Props = {
    row?: any,
    hideShowForm: (actionName) => void;
    getData: (page, pageSize, searchKey) => void;
    action?: string
};
export const GramamForm: React.FC<Props> = ({ row, hideShowForm, getData, action }) => {
    const dispatch = useAppDispatch();
    const iValue={gramam_id:0,gramam_name:'',upa_mandal_id:0,seq_no:0,is_active:''};
    const initialValue = action === 'edit' ? row : iValue;
    
    
    const formik = useFormik({
        initialValues: initialValue,
        onSubmit: async (values) => {
            if (action === 'edit') {
                const response = await updateGramam(row.gramam_id,values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setGramamMessage("Updated Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setGramamMessage("Some error occured!"));
                }
            } else if (action === 'add') {
                const response = await addGramam(values);
               if (response && (response.status === 200 || response.status === 201)) {
                    dispatch(setGramamMessage("Added Successfully"));
                    getData(Constant.defaultPageNumber, Constant.defaultPageSize, '');
                    hideShowForm('');
                } else {
                    dispatch(setGramamMessage("Some error occured!"));
                }
            }
        },
        validationSchema: yup.object({
           gramam_id: yup.number().required('gramam_id is required'),
gramam_name: yup.string().required('gramam_name is required'),
upa_mandal_id: yup.number().required('upa_mandal_id is required'),
seq_no: yup.number().required('seq_no is required'),
is_active: yup.boolean().required('is_active is required'),

        }),
    });
    return (
        <Card className="shadow mb-4">
            <Card.Header className="py-3">
                <h6 className="m-0 font-weight-bold text-primary text-capitalize">{action} Gramam
                    <Button className="btn-icon-split float-right" onClick={() => hideShowForm(false)}>
                        <span className="icon text-white-50">
                            <i className="fas fa-list"></i>
                        </span>
                        <span className="text">View Gramam</span>
                    </Button>
                </h6>

            </Card.Header>
            <Card.Body>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group>
<label className="form -control-label">gramam_id</label>
<Form.Control type="number" name="gramam_id" className="form-control" value={formik.values.gramam_id}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.gramam_id && !!formik.errors.gramam_id}
isValid ={!!formik.touched.gramam_id && !formik.errors.gramam_id}
></Form.Control>
{
    formik.errors.gramam_id && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.gramam_id}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">gramam_name</label>
<Form.Control type="text" name="gramam_name" className="form-control" value={formik.values.gramam_name}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.gramam_name && !!formik.errors.gramam_name}
isValid ={!!formik.touched.gramam_name && !formik.errors.gramam_name}
></Form.Control>
{
    formik.errors.gramam_name && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.gramam_name}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">upa_mandal_id</label>
<Form.Control type="number" name="upa_mandal_id" className="form-control" value={formik.values.upa_mandal_id}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.upa_mandal_id && !!formik.errors.upa_mandal_id}
isValid ={!!formik.touched.upa_mandal_id && !formik.errors.upa_mandal_id}
></Form.Control>
{
    formik.errors.upa_mandal_id && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.upa_mandal_id}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">seq_no</label>
<Form.Control type="number" name="seq_no" className="form-control" value={formik.values.seq_no}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.seq_no && !!formik.errors.seq_no}
isValid ={!!formik.touched.seq_no && !formik.errors.seq_no}
></Form.Control>
{
    formik.errors.seq_no && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.seq_no}</>
    </Form.Control.Feedback>
)}
</Form.Group>
<Form.Group>
<label className="form -control-label">is_active</label>
<Form.Control type="number" name="is_active" className="form-control" value={formik.values.is_active}
onChange={formik.handleChange}
onBlur ={formik.handleBlur}
isInvalid ={!!formik.touched.is_active && !!formik.errors.is_active}
isValid ={!!formik.touched.is_active && !formik.errors.is_active}
></Form.Control>
{
    formik.errors.is_active && (
    <Form.Control.Feedback type="invalid">
        <>{formik.errors.is_active}</>
    </Form.Control.Feedback>
)}
</Form.Group>

                    <Form.Group>
                        <Button type="submit" className="float-right" variant="primary">Save</Button>
                    </Form.Group>
                </Form>
            </Card.Body>
        </Card>
    );
}

